import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CartOptions from "./CartOptions";
import DrawerQuantity from "./DrawerQuantity";
import { connect } from "react-redux";
import {
  edit_quantity,
  remove_from_cart,
  setProduct,
} from "../../../store/actions";
import { fetchDeliveryTime } from "../../../store/actions/deliveryTime";
import { getDHLQuote, getAramexRate } from "../../../store/actions/shipping";
import { preciseNumber } from "../../../store/reducers/cart";
import { getMaximumProductInventoryFromModifiers } from "../../Menu/Helpers";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga4";

import { GTM } from "../../../App";
import {
  getDiscountedPrice,
  getProductDiscountAmount,
} from "../../../Helpers/promotions";
import { getProductInventory } from "../../../store/reducers/store";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";
class DrawerContent extends Component {
  removeFromCartAnalytics = (product) => {
    const { settings } = this.props;

    if (settings.enable_google_analytics && settings.google_analytics) {
      ReactGA.event({
        category: "Removed From Cart",
        action: `User Removed ${product.name} From Cart`,
        label: "Removed From Cart",
      });
    }

    ReactGA.gtag("event", "remove_from_cart", {
      value: product.price * product.quantity,
      currency: settings.currency_iso,
      items: [
        {
          item_id: product.id,
          item_name: product.name || "",
          price: product.price,
          quantity: product.quantity,
        },
      ],
    });
    if (GTM) {
      GTM.track("remove_from_cart", {
        ecommerce: {
          items: [
            {
              item_id: product.id,
              item_name: product.name,
              currency: settings.currency_iso,
              value: product.price,
              quantity: product.quantity,
            },
          ],
        },
      });
    }
  };
  getAddedQuantity = (store_product) => {
    let addedQuantity = 0;

    if (store_product.max_addable_quantity) {
      this.props.cart.forEach((product, index) => {
        if (
          product.id === store_product.id &&
          this.props.itemProps.itemIndex !== index
        )
          addedQuantity += product.quantity;
      });
    }

    return addedQuantity;
  };
  state = {
    quantity: this.props.itemProps.quantity,
  };
  ar_days = {
    Sun: "اﻷحد",
    Mon: "اﻷثنين",
    Tue: "الثلاثاء",
    Wed: "اﻷربعاء",
    Thu: "الخميس",
    Fri: "الجمعة",
    Sat: "السبت",
  };
  ar_months = {
    Jan: "يناير ",
    Feb: "فبراير",
    Mar: "مارس",
    Apr: "أبريل",
    May: "مايو",
    Jun: "يونيو",
    Jul: "يوليو",
    Aug: "أغسطس",
    Sep: "سبتمبر",
    Oct: "أكتوبر",
    Nov: "نوفمبر",
    Dec: "ديسمبر",
  };
  checkMinMaxOrPromo = (
    store_product,
    addedQuantity,
    newQuantity,
    PromoItem
  ) => {
    if (
      PromoItem ||
      ((store_product.max_addable_quantity === null ||
        newQuantity + addedQuantity <= store_product.max_addable_quantity) &&
        newQuantity >= store_product.min_addable_quantity)
    )
      return true;
    return false;
  };
  changeQuantity = (val) => {
    const newQuantity = preciseNumber(val + this.state.quantity);
    const store_product = this.props.itemProps.originalProduct;
    const addedQuantity = this.getAddedQuantity(store_product);
    const cart_item = this.props.itemProps.product;
    const usedComponents = this.props.usedComponents;

    if (cart_item.promo) {
      let discount_item;
      if (cart_item?.discountType === "category_free") {
        discount_item = this.props.promotions.category_free.find(
          (p) => p.id === cart_item.discount && p.promo === cart_item.promo
        );
      } else {
        discount_item = this.props.promotions.products.find(
          (p) =>
            p.id === cart_item.discount &&
            ((p.has_variants && p.product === cart_item.parent) ||
              (!p.has_variants && p.product === cart_item.id))
        );
      }
      if (discount_item) {
        if (
          newQuantity >
          discount_item.quantity + this.props.itemProps.quantity
        )
          return;
      } else {
        return;
      }
    }

    if (
      newQuantity > 0 &&
      this.checkMinMaxOrPromo(
        store_product,
        addedQuantity,
        newQuantity,
        cart_item.promo
      ) &&
      ((cart_item.is_preordered &&
        newQuantity <=
          store_product.preorder_inventory + this.props.itemProps.quantity) ||
        (!cart_item.is_preordered &&
          ["stocked", "composite"].includes(store_product.type_of_product) &&
          newQuantity <=
            getProductInventory(store_product, usedComponents) +
              this.props.itemProps.quantity) ||
        store_product.type_of_product === "produced" ||
        (store_product.type_of_product === "bookable" &&
          newQuantity <=
            store_product.booking_slots.find(
              (slot) => slot.id === this.props.itemProps.product.booking_slot
            ).inventory +
              this.props.itemProps.quantity)) &&
      (val <= 0 ||
        newQuantity <=
          getMaximumProductInventoryFromModifiers(
            cart_item.options,
            cart_item.quantity,
            usedComponents,
            null,
            null,
            store_product
          ))
    )
      this.setState({ quantity: newQuantity });
  };

  isInternationalDelivery = () => {
    if (
      (this.props.address?.country !== this.props.baseCountryID ||
        this.props.base_country_name === "Saudi Arabia") &&
      (this.props.settings.enable_dhl ||
        this.props.settings.enable_dhl_v2 ||
        this.props.settings.enable_aramex) &&
      this.props.address?.selectedDeliveryType === 0
    )
      return true;
    return false;
  };

  saveQuantity = () => {
    const { settings } = this.props;
    this.props.edit_quantity(
      this.props.itemProps.itemIndex,
      this.props.itemProps.product,
      this.state.quantity,
      this.state.quantity - this.props.itemProps.quantity,
      this.props.itemProps.product.promo ? true : false,
      this.props.itemProps.product.is_preordered
    );
    this.props.fetchDeliveryTime();
    if (
      (settings.enable_dhl || settings.enable_dhl_v2) &&
      this.isInternationalDelivery() &&
      (settings.enable_dhl_dynamic_rate || settings.enable_dhl_v2)
    ) {
      this.props.getDHLQuote();
    }
    if (this.isInternationalDelivery() && settings.enable_aramex) {
      this.props.getAramexRate();
    }

    if (settings.show_nutrition_facts) this.props.calculateNutritions();
  };
  getBooking = () => {
    const item = this.props.itemProps;

    let booking = item.originalProduct.booking_slots.find(
      (booking) => booking.id === this.props.itemProps.product.booking_slot
    );
    if (!booking) return null;
    let [year, month, day] = booking.booking_date.split("-");

    let date = new Date(year, month - 1, day);

    date = date.toString().split(" ");
    let day_numb = parseInt(date[2], 10);
    day = this.props.language === "english" ? date[0] : this.ar_days[date[0]];

    month =
      this.props.language === "english" ? date[1] : this.ar_months[date[1]];

    let formattedDate;
    if (!booking.all_day) {
      formattedDate = `${day} ${day_numb} ${month} - ${booking.start.slice(
        booking.start[0] === "0" ? 1 : 0,
        5
      )} `;

      if (this.props.settings.show_booking_end_slot) {
        formattedDate += ` ${
          this.props.language === "arabic" ? "حتى" : "to"
        } ${booking.end.slice(booking.end[0] === "0" ? 1 : 0, 5)}`;
      }
    } else {
      formattedDate = `${day} ${day_numb} ${month} - ${
        this.props.language === "arabic" ? "البوم باكمله" : "Whole Day"
      }`;
    }
    return <span>{formattedDate}</span>;
  };
  render() {
    const { language, settings, themeColor } = this.props;
    const item = this.props.itemProps; //All props passed down from the cart.js
    const discountedPrice = getProductDiscountAmount(
      item.product,
      this.props.coupon,
      this.props.promotions,
      this.props.store.smart_promos
    );

    const priceAfterDiscount = getDiscountedPrice(
      item.product.total_price * item.product.quantity +
        item.product.quantityExcludedOptionsTotal,
      discountedPrice,
      null,
      item.product.options,
      item.product.quantity
    );
    const currencyIcon = getCurrencyIcon(settings);

    return (
      <div>
        <h2
          className="mt-4 mx-auto mb-0"
          style={{ fontFamily: language == "english" ? "Quicksand" : "Cairo" }}
        >
          {item.name}
        </h2>

        {item.product.booking_slot && (
          <h5
            className="mt-4 mx-auto "
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
            }}
          >
            {this.getBooking()}
          </h5>
        )}
        <CartOptions
          product={item.product}
          originalProduct={this.props.itemProps.originalProduct}
          centerItems
        />
        {!item.product.promo && (
          <h4
            onClick={() => {
              this.props.setProduct(null);
              this.props.history.push({
                pathname: `/product/${item.originalProduct.category}/${
                  item.originalProduct.parent
                    ? `${item.originalProduct.parent}/`
                    : ""
                }${item.originalProduct.slug}`,
                state: {
                  editMode: true,
                  editedProduct: { ...item.product, index: item.itemIndex },
                },
              });
            }}
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              color: themeColor,
              cursor: "pointer",
            }}
          >
            {(language === "arabic" && "تعديل") || "Customize"}
          </h4>
        )}
        <Divider light className="mt-3" />
        {!this.props.itemProps.originalProduct.hide_quantity_box &&
          item.originalProduct.type_of_product != "service" && (
            <DrawerQuantity
              quantity={this.state.quantity}
              editQuantity={(val) => this.changeQuantity(parseFloat(val))}
              increments={item.originalProduct.increments}
            />
          )}
        <h5
          className="text-muted"
          style={{
            marginTop: 10,
            fontFamily: language == "english" ? "Quicksand" : "Cairo",
          }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language == "english" ? "Price:" : "السعر:"}{" "}
          {settings?.currency_iso === "SAR" ||
            (settings?.currency_iso === "AED" && (
              <span className={currencyIcon}></span>
            ))}
          {priceAfterDiscount.toFixed(settings.currency_decimals)}{" "}
          {language == "english"
            ? settings.currency_english
            : settings.currency_local}
        </h5>
        <Divider light />
        <div
          className="row mx-auto"
          style={{ width: "100%", position: "absolute", left: 0, bottom: 15 }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {!this.props.itemProps.originalProduct.hide_quantity_box &&
            item.originalProduct.type_of_product != "service" && (
              <div className="col">
                <Button
                  style={{
                    color: "green",
                  }}
                  onClick={() => {
                    this.saveQuantity();
                    this.props.closeModal();
                  }}
                >
                  {language == "english" ? "Save" : "حفظ"}
                </Button>
              </div>
            )}
          <div className="col">
            <Button
              style={{
                color: "red",
              }}
              onClick={async () => {
                await this.props.remove_from_cart(
                  item.itemIndex,
                  item.product,
                  item.product.promo ? true : false
                );
                this.removeFromCartAnalytics(item.product);
                if (
                  item.product.preparation_time ||
                  item.product.is_preordered
                ) {
                  this.props.fetchDeliveryTime();
                }
                if (settings.show_nutrition_facts) {
                  this.props.calculateNutritions();
                }
                if (this.isInternationalDelivery() && settings.enable_aramex) {
                  this.props.getAramexRate();
                }

                this.props.closeModal();
              }}
            >
              {language == "english" ? "Delete" : "حذف"}
            </Button>
          </div>
        </div>
        <div className="free-space-60"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    cart: state.cart.cart,
    themeColor: state.store.store.settings.dark,
    usedComponents: state.store.used_components,
    address: state.customers.address,
    baseCountryID: state.store.store.base_country_id,
    promotions: state.cart.discounts,
    coupon: state.cart.promos,
    store: state.store.store,
    base_country_name: state.store.store.base_country,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    edit_quantity: (
      product_index,
      item,
      quantity,
      change,
      is_promo_item,
      isPreordering
    ) =>
      dispatch(
        edit_quantity(
          product_index,
          item,
          quantity,
          change,
          is_promo_item,
          isPreordering
        )
      ),
    remove_from_cart: (item_index, item, is_promo_item) =>
      dispatch(remove_from_cart(item_index, item, is_promo_item)),
    fetchDeliveryTime: () => dispatch(fetchDeliveryTime()),
    setProduct: (product) => dispatch(setProduct(product)),
    getDHLQuote: () => dispatch(getDHLQuote()),
    getAramexRate: () => dispatch(getAramexRate()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DrawerContent));
